/* eslint-disable no-control-regex */
import z from "zod";

export const getFormSchema = () =>
  z.object({
    id: z.string().optional(),
    referenceNumber: z
      .union([z.string().optional(), z.undefined().optional()])
      .optional(),
    name: z
      .string()
      .min(1, "Group name is required")
      .max(100, "Group name must be at most 100 characters")
      .refine(value => /^[\u0000-\u007F]+$/.test(value), {
        message: "Only English letters, numbers and symbols are allowed.",
      })
      .trim(),
    country: z.string().min(1, "Country is required"),
    currency: z.string().min(1, "Currency is required"),
    status: z.string().optional(),
    active: z.boolean().optional(),

    legalEntityId: z
      .string()
      .transform(val => (val.trim() === "" ? undefined : val))
      .nullable()
      .optional(),
    brandsWithBranches: z
      .array(
        z
          .object({
            brandId: z.string().optional(),
            brandName: z.string().optional(),
            active: z.boolean().optional(),
            branches: z
              .array(
                z.object({
                  branchId: z.string().optional(),
                  branchName: z.string().optional(),
                  active: z.boolean().optional(),
                })
              )
              .optional(),
          })
          .optional()
      )
      .optional(),
  });

export type GroupInformationFormType = z.infer<
  ReturnType<typeof getFormSchema>
>;
